// 一ページのデータ数
export const PAGE_LIMIT = 20;

export const initPagination = {
  first: PAGE_LIMIT,
};
